<template>
  <div class="bottom-section flex flex-col justify-center">
    <div class="relative w-full flex flex-row justify-center">
      <slot name="default"></slot>
      <div
        class="absolute bottom-0 text-chplus-s"
        style="left:50%;transform:translate(-50%,100%);white-space: nowrap"
      >
        <slot name="info"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomSection"
};
</script>

<style lang="scss" scoped>
.bottom-section {
  height: 3.696rem;
  flex: 0 0 3.696rem;
}

@media (min-width: 768px) {
  .bottom-section {
    height: 4.224rem;
    flex: 0 0 4.224rem;
  }
}
</style>
